import { Outlet } from '@tanstack/react-router'
import { CommunicationNotificationsProvider } from '@/features/communications/notifications/communication-notifications'
import { WorkspaceAiChatLayout } from '@/features/ai-chat/workspace-ai-chat-layout'
import { AppFooter } from '@/app/shell/app-footer'
import Header from '@/app/shell/header'
import { SidePanel } from '@/app/shell/side-panel'
import { NavContent } from '@/app/shell/nav-content'
import { AddDocumentCollectionSheet } from '@/features/document-collection/add-document-collection-sheet'
import { useAppShellState } from '@/app/shell/use-app-shell-state'
import { useCurrentUserProfile } from '@/entities/user/model/use-current-user-profile'
import { useSyncLanguage } from '@/i18n/use-sync-language'
import { Toaster } from '@/shared/notifications/ui/sonner'
import { ThemeProvider } from '@/shared/theme/theme-context'

function AppShellContent() {
  const {
    collections,
    handleCreateCollection,
    handleMenuClick,
    handleNavigate,
    handleTogglePinnedMenuExpanded,
    handleTogglePin,
    isAddCollectionOpen,
    isDesktop,
    isMainNavigationExpanded,
    isNavOpen,
    isNavPinned,
    isPinnedMenuExpanded,
    setIsAddCollectionOpen,
    setIsNavOpen,
    showOverlay,
    showPinned,
  } = useAppShellState()

  const { currentUser } = useCurrentUserProfile()
  useSyncLanguage(currentUser?.preferredLanguage ?? null)

  const navContent = (
    <NavContent
      collections={collections}
      onNavigate={handleNavigate}
      onCreateCollection={handleCreateCollection}
      showMainNavigation={isMainNavigationExpanded}
    />
  )

  return (
    <ThemeProvider>
      <Toaster richColors closeButton />
      <div className="flex h-screen flex-col">
        <WorkspaceAiChatLayout
          navigationPinned={showPinned}
          header={
            <Header
              isNavPinned={isNavPinned}
              isDesktop={isDesktop}
              onMenuClick={handleMenuClick}
            />
          }
        >
          <div className="flex h-full min-h-0 overflow-hidden">
            {showPinned && (
              <SidePanel
                variant="pinned"
                onTogglePin={handleTogglePin}
                isMainNavigationExpanded={isPinnedMenuExpanded}
                onToggleMainNavigation={handleTogglePinnedMenuExpanded}
              >
                {navContent}
              </SidePanel>
            )}
            <main className="flex-1 overflow-auto">
              <Outlet />
            </main>
          </div>
          {showOverlay && (
            <SidePanel
              variant="overlay"
              isOpen={isNavOpen}
              onClose={() => setIsNavOpen(false)}
              onTogglePin={handleTogglePin}
              isDesktop={isDesktop}
            >
              {navContent}
            </SidePanel>
          )}
        </WorkspaceAiChatLayout>
        <AppFooter />
        <AddDocumentCollectionSheet
          open={isAddCollectionOpen}
          onOpenChange={setIsAddCollectionOpen}
          showTrigger={false}
        />
      </div>
    </ThemeProvider>
  )
}

export default function AppShell() {
  return (
    <CommunicationNotificationsProvider>
      <AppShellContent />
    </CommunicationNotificationsProvider>
  )
}
